import Service from '@/service/index'
export default {
    methods: {
        toggleFavourite (log_name) {
            const { favourite, id } = this.house
            const params = {
                followable_type: 'Fc::Building',
                followable_id: id
            }
            console.error('toggleFavourite', id)
            if (favourite) {
                Service.delFollow(params)
            } else {
                this.$sendCtmEvtLog(log_name)
                Service.addFollow(params)
            }
            this.house.favourite = !favourite
        }
    }
}
